import React, { useState } from 'react';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import Button from 'material-ui/FlatButton';
import './index.css';

function ClassMenu (props) {
    const {
        possibleClasses,
        userClasses,
        userId,
        isOpen,
        addClicked,
        addClass,
        removeClass,
        closeMenu,
        getClassesAssignments,
        getClassesSprints,
        getClassesFromIds,
        setClassIndex,
        handleAddClick,
        classId
    } = props;

    const [currentClass, setCurrentClass] = useState("");

    const getMappedClassOptions = () => {
        // value is the class _id (not the name): two classes can share a name,
        // and a name-based lookup would add the student to the wrong one.
        return possibleClasses && possibleClasses
                  .map((classObject) => {
                      return (
                          <MenuItem
                              key={classObject._id}
                              value={classObject._id}
                              primaryText={classObject.name}
                              id="class"
                          />
                      );
                  })
    }

    // material-ui SelectField onChange is (event, index, value); value is the class _id
    const handleDropdownChange = (e, index, value) => {
        setCurrentClass(value);
    }

    const handleAddNewClass = () => {
        const newUserClasses = [...(userClasses || [])];
        const newClassId = currentClass;
        newUserClasses.push(newClassId);
        if (currentClass.trim() !== "") {
            addClass(userId, newClassId);
            closeMenu();
            getClassesAssignments(newUserClasses);
            getClassesSprints(newUserClasses);
            getClassesFromIds(newUserClasses);
            setClassIndex(newUserClasses.length - 1);
        }
    }

    const handleRemoveClick = () => {
        if(removeClass) {
            removeClass(userId, classId);
        }
        closeMenu();
    }

    if (!isOpen) {
        return null;
    }

    if (addClicked) {
        return (
            <div className="classMenuWindow">
                <div className="dropdownMenu">
                    <div className="positionDropdown">
                        <SelectField
                            hintText={"Select Class"}
                            name="class"
                            value={currentClass}
                            onChange={handleDropdownChange}
                            fullWidth={true}
                            hintStyle={{paddingLeft: "15px"}}
                            labelStyle={{paddingLeft: "15px"}}
                            underlineStyle={{border: "none"}}
                        >
                            {getMappedClassOptions()}
                        </SelectField>
                    </div>
                </div>
                <Button disabled={(!currentClass)} onClick={handleAddNewClass} className="pinkBackground">Add Class</Button>
            </div>
        )
    }

    return (
        <div className="classMenuWindow">
            <h4 onClick={handleAddClick}>Add Class</h4>
            <h4 onClick={handleRemoveClick}>Remove Class</h4>
        </div>
    )
}

export default ClassMenu;
